import React from "react";
import { Route } from "react-router-dom";
import Careers from "../components/index";

const CareersRoutes = () => {
  return (
    <>
      <Route path="/careers" element={<Careers />} /> 
    </>
  );
};

export default CareersRoutes;
